import { createRequestActionTypes } from '../../helpers'

export const FETCH_TOPICS = createRequestActionTypes(
  'TRENDING_TOPICS',
  'FETCH_TOPICS'
)
